import React, { useEffect, useState } from "react";
import "./DataBasePage.css";
import InfoCard from "../../components/ui/InfoCard/InfoCard";
import { FaUniversity } from "react-icons/fa";
import { studiesService, exportService } from "../../service";
import Spinner from "../../components/ui/Spinner/Spinner";
import { toast } from "react-toastify";

const DatabasePage = () => {
  const [activeTab, setActiveTab] = useState("mine");
  const [myStudies, setMyStudies] = useState([]);
  const [otherStudies, setOtherStudies] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch studies
  useEffect(() => {
    const fetchStudies = async () => {
      try {
        setLoading(true);
        const { data: allStudies } = await studiesService.getMine();
        const { data: myStudiesList } = await studiesService.getOwn();

        const myIds = new Set(myStudiesList.map((s) => s.id));
        const others = allStudies.filter((s) => !myIds.has(s.id));

        setMyStudies(myStudiesList);
        setOtherStudies(others);
      } catch (error) {
        console.error("Erreur lors du chargement des études:", error);
        toast.error("Erreur lors du chargement des études.");
      } finally {
        setLoading(false);
      }
    };

    fetchStudies();
  }, []);

  //  Handle export actions
  const handleExport = async (studyId, type) => {
    try {
      if (type === "complete") {
        await exportService.exportComplete(studyId);
      } else {
        await exportService.exportSimple(studyId);
      }
      toast.success("Exportation lancée...");
    } catch (err) {
      console.error("Erreur export:", err);
      toast.error("Échec de l’exportation du fichier.");
    }
  };

  if (loading) return <Spinner size="lg" />;

  return (
    <main className="content-details flex-grow-1 pt-4 ">
      <div className="content-tab container-fluid">
        {/*  Tabs */}
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "mine" ? "active" : ""}`}
              onClick={() => setActiveTab("mine")}
            >
              Mes études
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "others" ? "active" : ""}`}
              onClick={() => setActiveTab("others")}
            >
              Autres études
            </button>
          </li>
        </ul>

        {/* Tab content */}
        <div className="tab-content-study-details p-3">
          {activeTab === "mine" ? (
            <div className="row g-3">
              {myStudies.length === 0 ? (
                <p>Aucune étude trouvée.</p>
              ) : (
                myStudies.map((study) => (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={study.id}>
                    <InfoCard
                      title={study.name}
                      Icon={FaUniversity}
                      actionType="Exporter complet"
                      count={study.forms?.length || 0}
                      unit="formulaires"
                      onClick={() => handleExport(study.id, "complete")}
                      showOptions={false}
                    />
                  </div>
                ))
              )}
            </div>
          ) : (
            <div className="row g-3">
              {otherStudies.length === 0 ? (
                <p>Aucune autre étude trouvée.</p>
              ) : (
                otherStudies.map((study) => (
                  <div className="col-6 col-md-3" key={study.id}>
                    <InfoCard
                      title={study.name}
                      Icon={FaUniversity}
                      actionType="Exporter simple"
                      count={study.forms_count || 0}
                      unit="formulaires"
                      onClick={() => handleExport(study.id, "complete")}
                    />
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default DatabasePage;
